module.exports = __webpack_public_path__ + "4c984ad81d50d7bf1290fc375f1aed2c.woff";